export { default } from './PageAudioguide.vue'
